const purchaseProcessForm = document.querySelector('.purchase-process-form');
const defaultAddress = document.querySelector('.purchase-process-form__default-address');

const toggleSlide = (element) => {
  const isVisible = element.offsetHeight > 0;
  if (isVisible) {
    slideUp(element, 300);
  } else {
    slideDown(element, 300, 'flex');
  }
};

const closeAllEditForms = (addresses, currentForm) => {
  addresses.forEach((addr) => {
    const form = addr.querySelector('.purchase-process-form__address-edit-hidden-form');
    if (form && form !== currentForm && form.offsetHeight > 0) {
      slideUp(form, 300);
    }
  });
};

const pickAddresses = () => {
  const addresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');

  addresses.forEach((address) => {
    const editButton = address.querySelector('.purchase-process-form__address-edit-button');
    const editForm = address.querySelector('.purchase-process-form__address-edit-hidden-form');

    address.addEventListener('click', (e) => {
      if (editForm && editForm.contains(e.target)) return;

      const clickedEdit = e.target.closest('.purchase-process-form__address-edit-button');

      removeActiveClass(addresses);
      address.classList.add('is-active');

      closeAllEditForms(addresses, editForm);

      if ((!editButton && editForm) || (clickedEdit && editForm)) {
        toggleSlide(editForm);
      }
    });
  });
};

const removeShippingFromCart = () => {
  const shippingPriceEle = document.querySelector('.prices-item__delivery');
  if (shippingPriceEle) {
    const priceLeftEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-left');
    const priceRightEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-right');
    priceLeftEle.innerHTML = priceLeftEle.dataset.label;
    priceRightEle.innerHTML = priceRightEle.dataset.label;
  }
};

const pasteAddress = () => {
  const savedAddresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');
  savedAddresses.forEach((savedAddress, key) => {
    const selectedAddress = savedAddress
      .closest('.purchase-process-form__addresses')
      .querySelector('.purchase-process-form__addresses__right');
    savedAddress.addEventListener('click', () => {
      selectedAddress.innerHTML = savedAddress.querySelector('.purchase-process-form__address-info').innerHTML;
      const mainAddress = selectedAddress.closest('.purchase-process-form__addresses-main');
      mainAddress.querySelector('input').value = key;
      mainAddress.dataset.code = savedAddress.dataset.code;
      removeShippingFromCart();
    });
  });
};

const initCompanySearch = () => {
  const companyWrapper = document.querySelector('.purchase-process-form__company');
  const searchButton = companyWrapper.querySelector('.btn');
  const vatInput = companyWrapper.querySelector('[name="tax_number"]');

  const clearInlineError = () => {
    const existingError = companyWrapper.querySelector('.purchase-process-form__company-error');
    if (existingError) {
      existingError.setAttribute('hidden', '');
    }
  };

  const clearValidationState = () => {
    if (vatFieldModInput) {
      vatFieldModInput.classList.remove('is-validation-failed');
    }
    clearInlineError();
    clearTimeout(validationFailedTimeout);
  };

  const setValidationFailed = (failed) => {
    if (vatFieldModInput) {
      vatFieldModInput.classList.toggle('is-validation-failed', failed);
    }
  };

  const showTemporaryValidationFailed = () => {
    setValidationFailed(true);
    clearTimeout(validationFailedTimeout);
    validationFailedTimeout = setTimeout(() => {
      setValidationFailed(false);
    }, 3000);
  };

  const vatFieldModInput = vatInput.closest('.mod-input');
  let validationFailedTimeout = null;

  searchButton.addEventListener('click', () => {
    const rawValue = vatInput.value.trim();
    const cleanedValue = rawValue.replace(/\s+/g, '').replace(/^SI/i, '');
    clearValidationState();

    if (!/^\d{6,}$/.test(cleanedValue)) {
      showTemporaryValidationFailed();
      return;
    }

    searchButton.disabled = true;
    searchButton.classList.add('is-loading');
    const runSearch = async () => {
      try {
        const response = await onFormSubmit({
          recaptchaKey: localData.captchaSiteKey,
          recaptchaAction: 'getCompanyData',
          formData: { vat: cleanedValue },
        });
        if (response.data.success) {
          const { data } = response.data;
          const fieldMappings = [
            { name: 'company_name', value: data.company },
            { name: 'company_address', value: data.address },
            { name: 'company_city', value: data.city },
            { name: 'company_post_number', value: data.zip },
            { name: 'company_country', value: data.country },
          ];

          fieldMappings.forEach(({ name, value }) => {
            if (value) {
              const field = document.querySelector(`[name="${name}"]`);
              if (field) {
                field.value = value;
                field.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }
          });
          clearValidationState();
        }
      } catch (err) {
        console.error(err);
        showTemporaryValidationFailed();
      } finally {
        searchButton.disabled = false;
        searchButton.classList.remove('is-loading');
      }
    };
    grecaptcha.ready(runSearch);
  });
};

const handleDropdownState = (dropdown, checked) => {
  const checkbox = dropdown.querySelector('.checkbox');
  const inputsDropdown = dropdown.querySelector('.purchase-process-form__checkbox-dropdown__inputs');

  if (!checkbox || !inputsDropdown) {
    return;
  }

  const isBusinessCheckbox = checkbox.closest('.purchase-process-form__business-invoice');

  if (checked) {
    slideDown(inputsDropdown, 300, 'flex');
  } else {
    slideUp(inputsDropdown, 300, 'none');

    const inputs = inputsDropdown.querySelectorAll('.mod-input');

    inputs.forEach((item) => {
      item.classList.remove('is-validation-failed');

      // const error = item.querySelector('.fv-plugins-message-container');
      // error.innerHTML = '';
    });
  }

  if (isBusinessCheckbox && defaultAddress) {
    defaultAddress.classList.toggle('hide', checked);
  }
};

if (purchaseProcessForm) {
  // Addresses accordion
  const mainAddress = purchaseProcessForm.querySelector('.purchase-process-form__addresses-main');
  if (mainAddress) {
    const parent = mainAddress.closest('.purchase-process-form__addresses');
    const content = parent.querySelector('.purchase-process-form__addresses-other');
    mainAddress.addEventListener('click', () => {
      mainAddress.classList.toggle('is-active');
      slideToggle(content, 300, 'flex');
    });
  }

  pickAddresses();

  // Checkbox dropdowns
  const dropdowns = document.querySelectorAll('.purchase-process-form__checkbox-dropdown');
  dropdowns.forEach((dropdown) => {
    const checkbox = dropdown.querySelector('.checkbox');

    if (!checkbox) {
      return;
    }

    const input = checkbox.querySelector('input');

    if (!input) {
      return;
    }

    // Initial state on load
    handleDropdownState(dropdown, input.checked);

    // Change listener
    input.addEventListener('change', (ev) => {
      handleDropdownState(dropdown, ev.currentTarget.checked);
    });
  });

  // Change button if paypal option is clicked
  const paymentDropdowns = document.querySelectorAll(
    '.purchase-process-dropdown--payment .purchase-process-dropdown__header',
  );
  paymentDropdowns.forEach((paymentDropdown) => {
    paymentDropdown.addEventListener('click', (ev) => {
      ev.target
        .closest('form')
        .querySelector('.purchase-process-form__footer-btns')
        .classList.toggle('show-paypal', ev.target.id === 'paypal');
    });
  });
  pasteAddress();
  initCompanySearch();
}

// *******************************************************
// Open login modal
// *******************************************************

attachEvent('.open-login-modal', 'click', (openLoginModal) => {
  openLoginModal.target.closest('.purchase-process-form').querySelector('.login-modal').classList.add('is-open-modal');
  toggleBodyScrollLock(true);
});

// *******************************************************
// Hide step 2 button if not checked
// *******************************************************
const checkTerms = document.getElementById('checkout_terms');
if (checkTerms) {
  const footer = document.querySelector('.sc-purchase-process-info-02 .purchase-process-form__footer');
  footer?.classList.toggle('is-active', checkTerms.checked);
  checkTerms.addEventListener('change', (e) => {
    footer?.classList.toggle('is-active', e.target.checked);
  });
}
